module.exports = __webpack_public_path__ + "static/media/facebook-dark.85eb9949.svg";